import type { IconProps } from '@shared/icons/types';
import type { ComponentType } from 'react';
import type { LotteryName } from '../../lottery-purchases/types';
import { ClientLottery } from '../../tippengine/lotteries/ClientLottery';
import { fetchLotteryConfig } from '../../tippengine/services/fetchLotteryConfig';
import { getNextSellableDrawing } from '../../tippengine/services/lotteryConfig';
import { LotteryError } from '../LotteryError/LotteryError';
import { LotteryFAQ } from '../LotteryFAQ/LotteryFAQ';
import { LotteryFaqSection } from '../LotteryFAQ/LotteryFaqSection';

type LotteryPageProps = {
  lotteryName: LotteryName;
  icon?: ComponentType<IconProps>;
};

/**
 * Shared play-page body. Each route keeps its own metadata and passes the lottery it serves.
 */
async function LotteryPage({ lotteryName, icon }: LotteryPageProps) {
  const lotteryConfig = await fetchLotteryConfig(lotteryName);

  if (!lotteryConfig) {
    return <LotteryError lotteryName={lotteryName} />;
  }

  const nextDrawing = getNextSellableDrawing({ ...lotteryConfig, drawings: lotteryConfig.drawings ?? [] }, Date.now());

  return (
    <>
      <ClientLottery lotteryName={lotteryName} lotteryConfig={lotteryConfig} icon={icon} />
      <LotteryFaqSection>
        <LotteryFAQ lotteryName={lotteryName} faqPage="lottery" closingDate={nextDrawing?.closingDate} drawingDate={nextDrawing?.drawingDate} />
      </LotteryFaqSection>
    </>
  );
}

export { LotteryPage };
export type { LotteryPageProps };
